import { render } from "./Checkbox.vue?vue&type=template&id=43f42a29&ts=true"
import script from "./Checkbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./Checkbox.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/checkbox/Checkbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43f42a29"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43f42a29', __exports__)) {
    api.reload('43f42a29', __exports__)
  }
  
  module.hot.accept("./Checkbox.vue?vue&type=template&id=43f42a29&ts=true", () => {
    api.rerender('43f42a29', render)
  })

}


export default __exports__